import { render } from "./Login.vue?vue&type=template&id=3533a8c7&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=3533a8c7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3533a8c7"

export default script